import { render, staticRenderFns } from "./root-element.vue?vue&type=template&id=3f31f94c"
import script from "./root-element.vue?vue&type=script&lang=js"
export * from "./root-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports